import { token } from '@cp/shared/di';
import { AsyncResult, Result } from '@youhelp-ru/core';
import { ClientProfileViewModel } from '@common/model/client';
import { ClientRegistrationState } from '@common/model/client/registration';
import { ClientSelection } from 'src/entities/client';

export const REGISTRATION_FEATURE =
  token<(sessionId: string, initialState: Partial<ClientRegistrationState>) => Promise<Result<ClientProfileViewModel, Error>>>(
    'REGISTRATION_FEATURE',
  );

export const CLIENT_SELECTION_GETTER = token<() => Promise<ClientSelection>>('CLIENT_SELECTIONS');
export const DEVICE_IDENTIFIER = token<() => Promise<string>>('DEVICE_IDENTIFIER');
export const QUIZ_FEATURE = token<(q: Array<keyof ClientSelection>) => AsyncResult<ClientSelection, Error>>('auth/QUIZ_FEATURE');

export const NOTIFICATION_UNSUBSCRIBE_FEATURE = token<() => AsyncResult<unknown, Error>>('NOTIFICATION_UNSUBSCRIBE_FEATURE');
